<template>
  <div class="flex flex-col items-center justify-center text-center" :style="{ minHeight: height + 'px' }">
    <div class="loading-spinner mb-3" />
    <p v-if="label" class="text-sm text-gray-400">{{ label }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingBlock',
  props: {
    height: { type: String, default: '200' },
    label: { type: String, default: 'Loading...' }
  }
}
</script>

<style scoped>
.loading-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #e5e7eb;
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
